// /src/components/activities/meditation/CustomToggle.jsx

import React from 'react';

const CustomToggle = ({ id, isOn, handleToggle, label }) => {
    return (
        <div className="flex items-center justify-between w-full">
            <label htmlFor={id} className="font-bold text-white cursor-pointer select-none">
                {label}
            </label>
            <button
                id={id}
                onClick={handleToggle}
                role="switch"
                aria-checked={isOn}
                className={`relative inline-flex items-center h-8 w-14 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-gray-800 ${
                    isOn ? 'bg-purple-600' : 'bg-gray-600'
                }`}
            >
                <span
                    aria-hidden="true"
                    className={`inline-block h-6 w-6 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out ${
                        isOn ? 'translate-x-7' : 'translate-x-1'
                    }`}
                />
            </button>
        </div>
    );
};

export default CustomToggle;